module.exports = __webpack_public_path__ + "14e090779798dcccc88085461294e2da.svg";